import { lazyDialog } from "~/hooks/useLazyDialog.ts";

// The dialogs hold the absence forms. Each loads after the page that mounts the hook (see `useLazyDialog`).
export const CreateAbsenceSidebar = lazyDialog(() => import("~/modules/absence/components/AbsencesView/components/CreateAbsenceSidebar"));
export const DeleteAbsenceModal = lazyDialog(() => import("~/modules/absence/components/AbsencesView/components/DeleteAbsenceModal"));
export const UpdateAbsenceSidebar = lazyDialog(() => import("~/modules/absence/components/AbsencesView/components/UpdateAbsenceSidebar"));
